import { eTransactionType } from '../eTransactionType';
import { eEndorsements } from 'ui-toolkit/enums/eEndorsements';

export interface IPolicyCalcEndorsementConfigResponse {
  transactionTypes: eTransactionType[];
  endorsementType: eEndorsements;
  minimum: number;
  percentOfPolicy: number;
  policyType: string; //  PreDiscountLender, Lender, Owner, All ?
}

export type IPolicyCalcEndorsementConfigData = IPolicyCalcEndorsementConfigResponse;

export const convertIPolicyCalcEndorsementConfigResponseToIPolicyCalcEndorsementConfigData = (
  response: IPolicyCalcEndorsementConfigResponse
): IPolicyCalcEndorsementConfigData => ({ ...response });
